import { createRouter, createWebHistory } from "vue-router";
import { routes } from "@/router/routes";
import appConfigs from "@/app/appConfigurations";
import { fakeBackendService } from "@/app/http/httpServiceProvider";
import { useRouter } from "vue-router";
import { userService } from "@/services/serviceProvider";

const router = createRouter({
  history: createWebHistory(),
  routes,
});

const title = "CAAT Complaints";

router.beforeEach((to, from, next) => {
  const auth = appConfigs.auth;
  const router = useRouter();

  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.title);

  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title + " | " + title || title;
  }

  const isAuthRequired = to.meta.authRequired;
  if (!isAuthRequired) {
    return next();
  }

  // if (auth === "fakebackend") {
  // const user = fakeBackendService.getUser();
  // const isUserLoggedIn = Object.keys(user).length > 0;

  // redirect to cannot access if no authorize for this page
  const expectedMenu = to.meta.expectedMenu as string;
  if (!userService.menuAccessibles().includes(expectedMenu)) {
    router.push("/pages/access-denied");
  }
  // if logged in -> redirect to actual page
  const isUserLoggedIn = userService.isLoggedIn();
  if (isUserLoggedIn) {
    
    next();
  } else {
    router.push("/logout");
  }
  
  // } else {
  //   next();
  // }
});

export default router;
